import axios from "axios";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
// Production must use the HTTPS origin that served the application. This
// prevents a build-time value from exposing an insecure backend address.
export const API_BASE = process.env.NODE_ENV === "production" || !configuredBackendUrl
  ? "/api"
  : `${configuredBackendUrl}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let refreshRequest = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error?.config;
    const path = String(original?.url || "");
    const canRefresh = error?.response?.status === 401 && original && !original._authRetry && !["/auth/login", "/auth/refresh", "/auth/logout"].some((route) => path.includes(route));
    if (!canRefresh) return Promise.reject(error);
    original._authRetry = true;
    try {
      if (!refreshRequest) refreshRequest = api.post("/auth/refresh").finally(() => { refreshRequest = null; });
      await refreshRequest;
      return api(original);
    } catch (_refreshError) {
      return Promise.reject(error);
    }
  },
);

export const formatApiDetail = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(formatApiDetail).filter(Boolean).join(" • ");
  if (detail && typeof detail === "object") {
    const field = Array.isArray(detail.loc) ? detail.loc.filter((item) => item !== "body").join(".") : "";
    const message = detail.message || detail.msg;
    if (message) return [detail.code, field, message].filter(Boolean).join(": ");
    if (detail.code && detail.warnings) return `${detail.code}: ${formatApiDetail(detail.warnings)}`;
    if (detail.code) return String(detail.code);
    const values = Object.entries(detail).map(([key, value]) => `${key}: ${formatApiDetail(value)}`).filter((value) => !value.endsWith(": "));
    return values.join(" • ") || "Request validation failed";
  }
  return detail == null ? "" : String(detail);
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  return formatApiDetail(detail) || err?.message || "Something went wrong";
};

export default api;
